var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E52B2",
    d: "M13.387 6.935h.458l-.232.397-.226-.397zm.458 2.13h-.458l.226-.397.232.397zM12 10.13l-.225-.398h.45L12 10.13zm-1.845-1.065l.232-.397.226.397h-.458zm0-2.13h.458l-.226.397-.232-.397zM12 5.87l.225.397h-.45L12 5.87zM13.23 8l-.615 1.065h-1.23L10.77 8l.615-1.065h1.23L13.23 8zM15 6.268h-2.002L12 4.534l-.998 1.732H9L9.998 8 9 9.732h2.002L12 11.466l.998-1.732H15L14.002 8 15 6.268zm9-5.266H0v2.003h24V1.003zm0 12H0v2.003h24v-2.003z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/Israel.9067a84e0e16f82d6e195d8405b7cf8f.svg";
export { ForwardRef as ReactComponent };